import type { SlidesPerViewConfig } from '@/shared/lib/use-slides-per-view';

export const MAX_SLIDES_COUNT = 15;

export const RATE_MAX = 5;
export const RATE_MIN = 4;

export const SLIDES_PER_VIEW: SlidesPerViewConfig[] = [
  { max: 319, slides: (total) => (total === 1 ? 0.98 : 1.1) },
  { min: 320, max: 440, slides: (total) => (total === 1 ? 0.98 : 1.19) },
  { min: 441, max: 480, slides: (total) => (total === 1 ? 0.98 : 1.25) },
  { min: 481, max: 680, slides: (total) => (total === 1 ? 0.98 : 1.55) },
  { min: 681, max: 768, slides: (total) => (total < 3 ? 1.9 : 1.75) },
  { min: 769, max: 800, slides: 1.85 },
  { min: 801, max: 980, slides: (total) => (total < 3 ? 1.91 : 2.1) },
  { min: 981, max: 1023, slides: (total) => (total < 3 ? 1.925 : 2.35) },
  {
    min: 1024,
    max: 1199,
    slides: (total) => {
      if (total < 3) {
        return 3;
      }

      return total === 3 ? 3 : 4;
    },
  },
  {
    min: 1200,
    slides: 3,
  },
];
